export const StepperENUM = { TOKEN: 0, ALLOTMENT: 1, BALANCE_SDR: 2, BALANCE_OCR_GST: 3, AGREEMENT: 4 };
